export default "__VITE_ASSET__Balx1KSs__"